import React, { FC, ReactNode, useRef, useState } from 'react';
import { LegacyButtonType } from 'antd/lib/button/button';

import Button, { ButtonProps } from 'ui/components/Buttons';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isThenable = (thing?: PromiseLike<any>): boolean => {
  return !!(thing && !!thing.then);
};

const convertLegacyProps = (type?: LegacyButtonType): ButtonProps => {
  if (type === 'danger') {
    return { danger: true };
  }
  return { type };
};

export const ModalButton: FC<IModalButtonProps> = ({
  close,
  actionFn,
  buttonProps,
  type,
  children,
}) => {
  const clickedRef = useRef(false);
  const [loading, setLoading] = useState<ButtonProps['loading']>(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handlePromiseOnOk = (returnValueOfOnOk?: Promise<any>) => {
    if (!isThenable(returnValueOfOnOk)) {
      return;
    }

    setLoading(true);
    returnValueOfOnOk
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ?.then((...args: any[]) => {
        close(...args);
      })
      .catch((e: Error) => {
        console.error(`confirm modal onOk - ${e}`);
      })
      .finally(() => {
        setLoading(false);
        clickedRef.current = false;
      });
  };

  const onClick = () => {
    if (clickedRef.current) {
      return;
    }

    clickedRef.current = true;

    if (!actionFn) {
      close();
      return;
    }

    let returnValueOfOnOk;

    if (actionFn.length) {
      returnValueOfOnOk = actionFn(close);
      // https://github.com/ant-design/ant-design/issues/23358
      clickedRef.current = false;
    } else {
      returnValueOfOnOk = actionFn();

      if (!returnValueOfOnOk) {
        close();
        return;
      }
    }

    handlePromiseOnOk(returnValueOfOnOk);
  };

  return (
    <Button {...convertLegacyProps(type)} loading={loading} onClick={onClick} {...buttonProps}>
      {children}
    </Button>
  );
};

export interface IModalButtonProps {
  type?: LegacyButtonType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  actionFn?: (...args: any[]) => any | Promise<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  close: (...args: any[]) => void;
  buttonProps?: ButtonProps;
  children?: ReactNode;
}
